import Vendor from '../utils/vendor';
import EventHelper from '../utils/eventHelper';

/**
 * 简易竖向slide
 * @param {*} config 
 */

function SlideV(config) {
    if(!config) {
        console.log('no config in slide');
        return;
    }
    /**
     * config
     * wrapperSelector  容器选择器
     * itemSelector     子选择器
     * slideTime        单帧停留时间ms
     * animateTime      动画时间ms
     * slideCallback    单次滑动回调函数
     */
    this.wrapperSelector = config.wrapperSelector || '.slidev-list-wrapper';
    this.itemSelector = config.itemSelector || '.slidev-item-wrapper';
    this.slideTime = config.slideTime || 2500;
    this.animateTime = config.animateTime || 300;
    this.slideCallback = config.slideCallback || null;
    this.firstCircle = true;
    this.init();
}

SlideV.prototype = {
    constructor: SlideV,
    init() {
        this.wrapper = document.querySelector(this.wrapperSelector);
        if(!this.wrapper) {
            console.log('not found wrapper');
            return;
        }
        this.slideList = this.wrapper.querySelectorAll(this.itemSelector);
        if(!this.slideList.length) {
            console.log('not found slide items');
            return;
        }
        this.slideList = this.wrapper.querySelectorAll(this.itemSelector);
        this.sum = this.slideList.length;
        this.slideInterval = null;
        // 如果只有1项，固定位置，不做滚动效果
        if(this.sum < 2) {
            // 检测曝光
            self.slideCallback && typeof self.slideCallback == 'function'  && self.slideCallback();
            return
        }else{
            this.setInitPosition();
            this.start();
        }
    },
    setInitPosition() {
        // 设置初始位置
        var self = this;
        const maxDistance = this.wrapper.clientHeight;
        this.prevPosition =  `-${maxDistance}px`;
        this.initPosition = '0';
        this.nextPosition =  `${maxDistance}px`;
        // 每个元素初始位置都是先用top偏移到视口内，在用transform偏移到是否上放一个身位
        [].slice.call(this.slideList).forEach(function(slideItem, index){
            slideItem.style.top = `-${index * maxDistance}px`;
            // 滑动到起始位置0
            if(index == 0) {
                slideItem.style[Vendor.transform] = `translate3d(0, ${self.initPosition}, 0)`;
                slideItem.style[Vendor.transition] = `all ${self.animateTime}ms`;
                // 检测曝光
                self.slideCallback && typeof self.slideCallback == 'function' && self.slideCallback();
                self.nowIndex = 0;
            }else {
                slideItem.style[Vendor.transform] = `translate3d(0, ${self.nextPosition}, 0)`;
            }
        });
    },
    start() {
        // 开始滑动
        var self = this;
        // 开始计时器，由于iphoneUE、iphone8的UC浏览器可能出现transtion失效问题，改变位置手动延迟300ms，故此处减去300ms
        if(!this.slideInterval) {
            this.slideInterval = setInterval(function() {
                self.slideTo(self.nextIndex(self.nowIndex));
            }, this.slideTime - 300);
        }else{
            clearInterval(this.slideInterval);
            this.slideInterval = null;
        }
    },
    slideTo(index) {
        // 滑动到特定的index
        var self = this;
        //set index
        this.nowIndex = index;
        // 当前帧的transition设置
        self.slideList[self.nowIndex].style[Vendor.transition] = `all ${self.animateTime}ms`;
        // 各有关帧位置归位，由于iphoneUE、iphone8的UC浏览器可能出现transtion失效问题，手动延迟300ms
        setTimeout(() => {
            this.slideList[this.prevIndex(this.nowIndex)].style[Vendor.transform] = `translate3d(0, ${this.prevPosition}, 0)`;
            this.slideList[this.nowIndex].style[Vendor.transform] = `translate3d(0, ${this.initPosition}, 0)`;
        }, 300);
        const target = self.slideList[self.nowIndex];
        // 动画结束之后，把上一帧移到底部并取消动画
        const transitionHandler = function(e) {
            self.slideList[self.prevIndex(self.nowIndex)].style[Vendor.transition] = `none`;
            self.slideList[self.prevIndex(self.nowIndex)].style[Vendor.transform] = `translate3d(0, ${self.nextPosition}, 0)`;
            EventHelper.removeHandler(target, Vendor.transitionEndEvent, transitionHandler);
            // 检测曝光
            self.slideCallback && typeof self.slideCallback == 'function' && self.slideCallback();
        }
        EventHelper.addHandler(target, Vendor.transitionEndEvent, transitionHandler);
        // 滚完一圈之后，标示改变
        if(index == this.slideList.length-1) {
            this.firstCircle = false;
        }
    },
    prevIndex(index) {
        return index == 0 ? this.sum -1 : index - 1;
    },
    nextIndex(index) {
        return index == this.sum - 1 ? 0 : index + 1;
    }
}

export default SlideV